//Library Imports
import React from "react";

//Local Imports
import { ReactComponent as Elipsis } from "assets/img/icons/Elipsis.svg";
import { ReactComponent as GroupIcon } from "assets/img/icons/Group_icon.svg";
import MenuPopUp from "./MenuPopUp";

//Style Imports
import styled from "styled-components";
import { removeOnClickBubble } from "utils";

interface IGroupListItem {
  id: number;
  name: string;
  time: string;
  contactCount: number;
  onClick?: any;
  onDeleteHandler?: any;
  isEditable?: any;
}

const GroupListItem: React.FC<IGroupListItem> = (props) => {
  const { id, name, time, contactCount, onClick, onDeleteHandler, isEditable } = props;
  const onClickEllipsis = (e: any) => {
    removeOnClickBubble(e);
  };
  return (
    <Wrapper onClick={onClick}>
      <div className="main">
        {/* Main */}
        <div className="group-logo">
          {/* Group Icon */}
          <StyledGroupLogo />
        </div>
        <div className="body-content">
          {/* Body */}
          <p className="group-name">{name}</p>
          <p className="group-time">{time}</p>
        </div>
        <div className="right-side">
          <div>
            {/* Contact Count */}
            <StyledGroupLogoTwo />
            <p className="contact-count">{contactCount}</p>
          </div>
        </div>
        <div className="menu">
          {/* Menu */}
          <MenuPopUp
            groupId={id}
            handleOnDelete={() => {
              // removeOnClickBubble(e);
              onDeleteHandler();
            }}
            isEditable={isEditable}
          >
            <div onClick={onClickEllipsis}>
              <StyledElipsis />
            </div>
          </MenuPopUp>
        </div>
      </div>
    </Wrapper>
  );
};

export default GroupListItem;

const Wrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  background-color: white;
  border-bottom:1px solid #DDDDDD;
  &:hover {
    cursor: pointer;
  }
  .main {
    display: flex;
    align-items: center;
    height: 80px;
  }
  .group-logo {
    height: 54px;
    width: 54px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.2);
    box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.08);
    margin-left: 16px;
    @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 40px;
      width: 40px;
    }
  }
  .group-name {
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.75px;
    margin-left: 15px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    color:#000000;
    @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 16px;
    }
  }
  .group-time {
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    color:#424B50;
    margin-left:15px;
    @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
  p {
    margin-bottom: 0;
  }
  .right-side {
    margin-left: auto;
  }
  .contact-count {
    height: 13px;
    font-family: "Roboto Slab";
    font-style: normal;
    font-weight: 900;
    font-size: 10px;
    line-height: 13px;
    text-align: center;
    color: #616f78;
    @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 8px;
    }
  }
  .menu {
    margin-right: 8px;
    margin-left: 8px;
    div {
      padding: 10px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .body-content {
    width: calc(100% - 250px);
  }
`;

const StyledGroupLogo = styled(GroupIcon)`
  height: auto;
  width: 30px;
  @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    width: 24px;
  }
`;
const StyledGroupLogoTwo = styled(GroupIcon)`
  height: 12px;
  width: auto;
  @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    height: 10px;
  }
`;
const StyledElipsis = styled(Elipsis)`
  height: 23px;
  width: 5px;
  @media (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    height: 20px;
    width: 4px;
  }
`;
